<template>
  <div class="align-middle">
    <toggle-button :key="toggleKey" v-model="toggleValue" @change="fnCallback" :color="color" :sync="true" :labels="true" />
  </div>
</template>
<script>
import _ from 'lodash';
import { ToggleButton } from 'vue-js-toggle-button';

/**
 * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR Toggles SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
 * */
export default {
  name: 'cell-dt-toggle-type',
  components: {
    ToggleButton,
  },
  data() {
    return {
      toggleValue: this.value,
    };
  },
  props: ['value', 'enabled', 'color', 'index', 'toggleKey'], //['value', 'outcomes', 'format'],
  computed: {},
  methods: {
    fnCallback() {
      this.$emit('btn-click');
    },
  },
};
</script>
<style scoped>
.cellBooleanType {
  text-align: center;
}

.align-middle {
  vertical-align: middle;
}
</style>
